import { defineMessages } from 'react-intl'

const messages = {
    title: {
        id: 'app.components.notification-gate.title',
        defaultMessage: 'Enable notifications',
    },
    bodyPrompt: {
        id: 'app.components.notification-gate.body-prompt',
        defaultMessage: 'Deliverider uses notifications to alert you about new orders. Notifications are required to log in.',
    },
    bodyDenied: {
        id: 'app.components.notification-gate.body-denied',
        defaultMessage: 'Notifications are turned off, and they are required to log in. Please turn them on to continue:',
    },
    stepsIos: {
        id: 'app.components.notification-gate.steps-ios',
        defaultMessage: '1. Tap "Open Settings" below\n2. Tap "Notifications"\n3. Turn on "Allow Notifications"\n4. Return to this screen',
    },
    stepsAndroid: {
        id: 'app.components.notification-gate.steps-android',
        defaultMessage: '1. Tap "Open Settings" below\n2. Turn on "Allow notifications"\n3. Return to this screen',
    },
    enable: {
        id: 'app.components.notification-gate.enable',
        defaultMessage: 'Enable notifications',
    },
    openSettings: {
        id: 'app.components.notification-gate.open-settings',
        defaultMessage: 'Open Settings',
    },
    cancel: {
        id: 'app.components.notification-gate.cancel',
        defaultMessage: 'Cancel',
    },
}

export default defineMessages(messages)
